import { getSrcImageFixed, ImageProxy, ImageFixed, ImageFluid, getSrcImage } from './image'

export { getSrcImageFixed, ImageFixed, ImageFluid, getSrcImage }

export default ImageProxy
